/**
 * @fileoverview A situação da cobrança da conta ativa, lida de GET
 * /account/status: na Empresa nos planos, as licenças (Usuários, o cadastro de
 * usuário e o convite travam o Chat Interno sem licença), o atraso, a
 * suspensão e o acesso restrito (os avisos do layout); na de antes dos planos,
 * só "legado". Relida a cada 10 minutos e quando o servidor avisa pelo socket
 * (company-<id>-billing). Saiu do contexto do onboarding antigo (bloco 5 da
 * etapa 5 dos planos).
 */

import React, { createContext, useCallback, useContext, useEffect, useState } from "react";

import { SocketContext } from "../Socket/SocketContext";
import api from "../../services/api";
import { isPublicPage } from "../../utils/publicPages";
import { isOnboardingSession } from "../../utils/decodeJwtPayload";

const BillingContext = createContext({ billing: null, refetchBilling: () => Promise.resolve(null) });

const REFRESH_MS = 10 * 60 * 1000;

export const BillingProvider = ({ children }) => {
  const [billing, setBilling] = useState(null);
  const socketManager = useContext(SocketContext);

  const refetchBilling = useCallback(async () => {
    // Sem conta ainda (a sessão do onboarding) ou numa página pública, não há cobrança para ler.
    if (isPublicPage() || isOnboardingSession() || !localStorage.getItem("token")) return null;
    try {
      const { data } = await api.get("/account/status");
      setBilling(data);
      return data;
    } catch (err) {
      return null; // a cobrança nunca derruba a tela
    }
  }, []);

  useEffect(() => {
    refetchBilling();
    const timer = setInterval(refetchBilling, REFRESH_MS);
    // A API recusou por acesso restrito (etapa 9): relê na hora (quem não cuida da cobrança não recebe o aviso pelo socket).
    window.addEventListener("billing:refresh", refetchBilling);
    return () => {
      clearInterval(timer);
      window.removeEventListener("billing:refresh", refetchBilling);
    };
  }, [refetchBilling]);

  useEffect(() => {
    const companyId = localStorage.getItem("companyId");
    if (!companyId || !socketManager) return undefined;
    const socket = socketManager.getSocket(companyId);
    const onBilling = () => refetchBilling();
    socket.on(`company-${companyId}-billing`, onBilling);
    return () => socket.off(`company-${companyId}-billing`, onBilling);
  }, [socketManager, refetchBilling]);

  return <BillingContext.Provider value={{ billing, refetchBilling }}>{children}</BillingContext.Provider>;
};

export const useBilling = () => useContext(BillingContext);

export default BillingContext;
